<span class="value">{{value(data, property, false, isAmount)}}</span>&nbsp;
<span class="delta">({{value(data, property, true, isAmount)}})</span>


// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/_component/data-analysis-value.component.html